import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { Table, Button,  Modal, ModalHeader, ModalBody, ModalFooter, Alert, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import TextFormInput from "../../components/Shared/Forms/TextFormInput";
import FormError from "../../components/Shared/Forms/FormError";
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import { EmpowerTask } from "../../interfaces/models/EmpowerTask"
import Loading from '../../components/Loading';
import React, { useState, useRef, useEffect } from "react"
import { Field, Form, Formik, FormikProps } from "formik";
import useImageUpload from "../../hooks/useImageUpload";
import { useMutation, useQuery } from "@apollo/client";
import { executeDeleteImage} from "../../graphql/queries/getImageUploadURL";
import EditEmpowerMeNudgeValidator from "../../validators/EditEmpowerMeNudgeValidator"
import toast from "react-hot-toast";
import { getEmpowerMeTasksSorted, editEmpowerMeNudge, createEmpowerMeNudge } from "../../graphql/empower-me/EmpowerMeQueries"
import ImageUploadInput from '../../components/ContentManagement/ImageUploadInput';
import { useCategoriesEmpowerMe } from "../../hooks/useCategories"
import Category from '../../interfaces/models/Category';
import ToggleableImage from "../../components/Shared/ToggleableImage"

interface ModalLabels {
    name : string;
    buttonName : string;
    action : string;
}

interface DataFormik {
    id : string,
    image_id : string;
    description : string;
    name : string;
    category : string;
}

interface FilterParams {
    search : string;
    category : string;
}

const EmpowerMeContentEditorPage = () => {

//#region Initialization
    const breadcrumbsData = [
        { name: 'Content List', path: `${DASHBOARD_ROOT}/content-management/` },
        { name: 'Edit Empower ME', path: `${DASHBOARD_ROOT}/content-management/empower-me` },
    ];

    const [empowerMeItems, setEmpowerMeItems] = useState<EmpowerTask[]>([]);
    const [empowerMeItemsFiltered, setEmpowerMeItemsFiltered] = useState<EmpowerTask[]>([]);
    const [categories, setCategories] = useState<Category[]>([]);
    const [subCategories, setSubCategories] = useState<Category[]>([]);

    const [tobeEdited, setToBeEdited] = useState<DataFormik>(null);
    const formikRef = useRef<FormikProps<DataFormik>>(null);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isOnProcess, setIsOnProcess] = useState<boolean>(false);

    const [modalLabels, setModalLabels] = useState<ModalLabels>({
        name : "",
        buttonName : "",
        action : ""
    });
    const [filters, setFilters] = useState<FilterParams>({
        search : "",
        category : ""
    });

    const [blobFile, setBlobFile] = useState<File>(null);
    const [url, setUrl] = useState<string>("");
    const [fileId, setFileId] = useState<string>("");
    const imageInputRef = useRef<{ clearImageField: () => void, refetchUrl: () => void }>(null);

    const [isActivating, setIsActivating] = useState<boolean>(false);

    const [createEmpowerMeNudgeHook] = useMutation(createEmpowerMeNudge,{
        onCompleted : () =>{
            toast.success("Empower ME Nudge was successfully created");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Creating Empower ME Nudge . Please try again or if issue persists, please contact us");
        }
    });

    const [editEmpowerMeNudgeHook] = useMutation(editEmpowerMeNudge,{
        onCompleted : () =>{
            toast.success("Empower ME Nudge was successfully updated");
        },
        onError : () =>{
            toast.error("Something went wrong whilst Updating Empower ME Nudge . Please try again or if issue persists, please contact us");
        }
    });

    
    const { data : categData, loading : categLoading} = useCategoriesEmpowerMe();

    const {
        loading : emLoading,
        error : emError,
      } = useQuery(getEmpowerMeTasksSorted, {
        onCompleted(data) {
            setEmpowerMeItems(data.empower_me_tasks_sorted_by_actives);
            setEmpowerMeItemsFiltered(data.empower_me_tasks_sorted_by_actives);
        },
        onError(error) {
          console.log(error);
        },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true, // Useful for invoking `onCompleted` during `refetch` calls
      });

      const Reloader = () =>{
        setTimeout(function() {
            window.location.reload();
        },1500)
    }

    const DeleteFileExecute = async (fileIdCloud : string) => {
        if(!fileIdCloud){
            return; 
        }
        try{
            await deleteFile({
                variables : {
                    fileId : fileIdCloud
                },
            })
        }
        catch(err){
            console.log(err);
        }
    }

    const { uploadImage } = useImageUpload();
    const [deleteFile] = useMutation(executeDeleteImage);

    const SetupCategoryOptions = () => {
        return (
            categories.map((item, index) => 
                <React.Fragment key={index}>
                    <optgroup label={item.description}>
                        {
                            subCategories.filter(u => u.parent_id === item._id).map((subItem, subIndex) => (
                                <option key={subIndex} value={subItem._id}>{subItem.description}</option>
                            ))
                        }
                    </optgroup>
                </React.Fragment>
            )
        )
    }

    const FilterEmpowerMeItems = (search : string, category : string) => {

        search =search?.toLowerCase()

        setEmpowerMeItemsFiltered(empowerMeItems.filter( u => 

            (search === "" || (u.name.toLowerCase().includes(search) || u.description?.toLowerCase().includes(search))) &&
            (category === "" || (u.task_category?._id === category))
        ))
    }

    const HandleSearchOnKeyUp = (search : string) => {
        FilterEmpowerMeItems(search, filters.category);
    }

    const HandleCategoryChange = (value : string) => {
        setFilters((prev) => ({ ...prev, category : value }));
        FilterEmpowerMeItems(filters.search, value);
    }
    

    useEffect(() => {
        if(categData) {
            const categRaw : Category[] = categData.categories_empower_me; 
            setCategories(categRaw.filter(u => u.level === 2));
            setSubCategories(categRaw.filter(u => u.level === 3));
        }
    }, [categData]);

//#endregion Initialization
//#region Add and Edit Functions
    const ToggleModal = () => {
        imageInputRef.current?.clearImageField();
        setIsModalOpen(!isModalOpen);
    }
    
    const HandleOpenAdd = () =>{

        setToBeEdited({
            id : "1",
            name : "",
            description : "",
            image_id : "",
            category : "",
        });

        setModalLabels({
            name : "Add Em Nudge",
            buttonName : "Add",
            action : "add"
        });

        ToggleModal();
    }

    const HandleEdit = (item : EmpowerTask) =>{

        setToBeEdited({
            id : item._id,
            name : item.name,
            description : item.description,
            image_id : item.image_id,
            category : item.task_category._id
        });

        setModalLabels({
            name : "Edit Em Nudge",
            buttonName : "Edit",
            action : "edit"
        });

        ToggleModal();
    }

    const HandleSubmit = async (formData : DataFormik) => {
        if(isOnProcess){
            return;
        }

        setIsOnProcess(true)
        if(blobFile){
            const isUploaded = await uploadImage(url,blobFile);
            if(!isUploaded){
                toast.error("Something went wrong whilst uploading your image. Please try again or if issue persists, please contact us");
                setIsOnProcess(false);    
                return;
            }
        } else {
            setFileId(null);
        }

        let processedImage = null
        if(fileId) {
            processedImage = fileId
        }
        else if (formData.image_id) {
            processedImage = formData.image_id
        }

        if(modalLabels.action === "add") {

            createEmpowerMeNudgeHook({
                variables :{
                    record : {
                        name : formData.name,
                        description : formData.description,
                        image_id : processedImage,
                        category : formData.category
                    }
                }
            })
            .then(async (res)=>{
                if(res.errors){
                    setIsOnProcess(false);
                    await DeleteFileExecute(fileId);
                    imageInputRef.current?.refetchUrl();
                }else {
                    
                    Reloader();
                }
            })
            .catch(()=>{
                imageInputRef.current?.refetchUrl();
                setIsOnProcess(false);
            })
        }
        else if(modalLabels.action === "edit") {
            editEmpowerMeNudgeHook({
                variables :{
                    _id : tobeEdited.id,
                    record : {
                        name : formData.name,
                        description : formData.description,
                        image_id : processedImage,
                        category : formData.category
                    }
                }
            })
            .then(async (res)=>{
                if(res.errors){
                    setIsOnProcess(false);
                    await DeleteFileExecute(fileId);
                }
                else{
                    if(fileId && tobeEdited.image_id) {
                        await DeleteFileExecute(tobeEdited.image_id);
                    }
                    Reloader();
                }
            })
            .catch(()=>{
                setIsOnProcess(false);
            });
        }

        
    }

    const ToggleActivation = (item : EmpowerTask) => {

        if(isActivating) {
            return;
        }
        setIsActivating(true);
        let newStatus = ! (item.is_active || false);

        // if(newStatus === true) {
        //     //check if there is 5 active items related to category
        //     const empowerMeActiveItems = empowerMeItems.filter( (u : EmpowerTask )=>  u.task_category.description === item.task_category.description && u.is_active === true).length;
        //     if(empowerMeActiveItems === 10) { 
        //         toast.error("Sorry, there can be a maximum of 10 active items per category.");
        //         setIsActivating(false);
        //         return;
        //     }
        // }

        editEmpowerMeNudgeHook({
            variables :{
                _id : item._id,
                record : {
                    is_active : newStatus
                }
            }
        })
        .then(async (res)=>{
            if(res.errors){
                setIsActivating(false);
            }
            else{
                setEmpowerMeItems((prevItems : EmpowerTask[]) => {
                    const index = prevItems.findIndex(u => u._id === item._id);
                    if (index === -1) return prevItems;
                
                    const newItems = [...prevItems];
                    const updatedItem = { ...newItems[index], is_active: newStatus };
                    newItems[index] = updatedItem;
                    return newItems;
                });
                setIsActivating(false);
            }
        })
        .catch(()=>{
            setIsActivating(false);
        })
    }

//#endregion Edit Functions
    
//#region Image sync 
const HandleImageChange = (url : string, fileId : string, blob : File) => {
    setUrl(url);
    setFileId(fileId);
    setBlobFile(blob);
}

const IsFetchingToggle = (isGetting : boolean) =>{
    setIsOnProcess(isGetting);
}
//#endregion Image sync 
    return (
        <>
            <Breadcrumbs 
                crumbs={breadcrumbsData}
            />
            <div className="d-flex justify-content-end">
                <Button color="primary" onClick={HandleOpenAdd}>Add</Button>
            </div>
            <Row className="pt-3">
                <Col>
                    <FormGroup className="d-flex">
                        <Label className="pt-2 pr-2">
                            Seach: 
                        </Label>
                        <Input
                            type="search"
                            placeholder="Search name and description here"
                            value={filters.search}
                            onChange={(e) => setFilters((prev) => ({...prev, search : e.target.value }))}
                            onKeyUp={(e) => HandleSearchOnKeyUp(e.currentTarget.value)}
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="d-flex">
                        <Label className="pt-2 pr-2">
                            Category: 
                        </Label>
                        <Input
                            name="select"
                            type="select"
                            value={filters.category}
                            onChange={(e) => HandleCategoryChange(e.currentTarget.value)}
                            disabled={categLoading}
                        >
                            <option value="">All</option>
                            {SetupCategoryOptions()}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
            {
                emError &&
                <Alert color="danger">
                    Oops, we’re having trouble getting the EM nudges. Please give it a minute, and if it doesn’t resolve, let us know.
                </Alert>
            }
            <div className="table-responsive table-max-height">
                <Table bordered  className="bg-white">
                    <thead>
                        <tr className="sticky-top bg-white">
                            <th>Image</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            emLoading &&
                            <tr>
                                <td colSpan={5}>
                                    <Loading />
                                </td>
                            </tr>
                        }
                        {
                            empowerMeItemsFiltered.length === 0 && !emLoading &&
                            <tr>
                                <td colSpan={5} className="text-center">No Data Found</td>
                            </tr>
                        }
                        {
                            empowerMeItemsFiltered.map((item : EmpowerTask, index : number) => {
                                return (
                                    <tr key={index}>
                                        <td className="text-center">
                                            <ToggleableImage image={item.image_id ?? item.task_category.image } />
                                        </td>
                                        
                                        <td>
                                            <div style={{ width : 250, maxWidth : 250, 
                                                wordWrap :"break-word", overflowWrap :"break-word", 
                                                whiteSpace: "normal" }}>
                                                {item.name}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ width : 250, maxWidth : 250, 
                                                wordWrap :"break-word", overflowWrap :"break-word", 
                                                whiteSpace: "normal" }}>
                                                {item.description}
                                            </div>
                                        </td>
                                        <td>{item.task_category.description}</td>
                                        <td>
                                            
                                            <Button color="primary" size='sm'onClick={()=>{ HandleEdit(item) }} >Edit</Button>
                                            {
                                                item.is_active === true ? 
                                                <Button color="danger" disabled={isActivating} size='sm'onClick={()=>{ ToggleActivation(item) }} >Deactivate</Button>
                                                :
                                                <Button color="success" disabled={isActivating} size='sm'onClick={()=>{ ToggleActivation(item) }} >Activate</Button>
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        
                    </tbody>
                </Table>
            </div>
            <Modal
                id="empowerme-edit-modal"
                className="modal-lg"
                backdrop={true}
                isOpen={isModalOpen}>
                <ModalHeader toggle={ToggleModal} className="pb-0">
                    <p className="text-lg">{modalLabels.name}</p>
                </ModalHeader>
                <ModalBody>
                    <Formik
                        innerRef={formikRef}
                        initialValues={tobeEdited}
                        validationSchema={EditEmpowerMeNudgeValidator}
                        onSubmit={async (value : DataFormik) =>{
                            await HandleSubmit(value);
                        }}
                    >
                        {({ errors, touched }) => (
                            <Form>
                                <TextFormInput
                                    name={"name"}
                                    placeholder="Enter Name"
                                    label="Name"
                                    required={true}
                                    className="mb-3"
                                />
                                <div className="form-group">
                                    <label>Description </label>
                                    <Field
                                        className="form-control"
                                        name="description"
                                        placeholder="Enter Description"
                                        as="textarea"
                                    />
                                    <FormError>{touched.description && (errors.description)}</FormError>
                                </div>
                                <FormGroup>
                                    <Label>
                                        Category
                                    </Label>
                                    <Field
                                        name="category"
                                        as="select"
                                        className="form-control"
                                        disabled={categLoading}
                                    >
                                        <option value="">Please Select</option>
                                        {SetupCategoryOptions()}
                                    </Field>
                                    <FormError>{touched.category && (errors.category)}</FormError>
                                </FormGroup>
                                <ImageUploadInput
                                    ref={imageInputRef}
                                    formikRef={formikRef}
                                    transferFunction={HandleImageChange}
                                    isGettingUrl={IsFetchingToggle}
                                    imageName="image"
                                    imageIdName="image_id"
                                    extensionAllowed="image/jpeg,image/jpg"
                                    isDisabled={isOnProcess}
                                />

                            </Form>
                        )}
                    </Formik>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" disabled={isOnProcess } onClick={ToggleModal} >Close</Button>
                    <Button color="primary" disabled={isOnProcess } onClick={() => { formikRef?.current.submitForm(); }} >{modalLabels.buttonName}</Button>
                </ModalFooter>
            </Modal>
        </>
    )

}


export { EmpowerMeContentEditorPage as EmpowerMeContentEditor };